module.exports = __webpack_public_path__ + "img/PALERMO.2831aeb4.png";